import { KnownSetKioskThemeDtoTheme, SetKioskThemeDtoTheme } from '@groundfloor-platform/mgmt-service-g-sdk';

export interface KioskThemePresetOption {
  value: SetKioskThemeDtoTheme;
  label: string;
}

export const KIOSK_THEME_PRESET_OPTIONS: KioskThemePresetOption[] = [
  { value: KnownSetKioskThemeDtoTheme.GroundfloorLight, label: 'Groundfloor Light' },
  { value: KnownSetKioskThemeDtoTheme.GroundfloorDark, label: 'Groundfloor Dark' },
  { value: KnownSetKioskThemeDtoTheme.LastkLight, label: 'LastK Light' },
  { value: KnownSetKioskThemeDtoTheme.LastkDark, label: 'LastK Dark' }
];
